import { render, staticRenderFns } from "./PagesList.vue?vue&type=template&id=2cf718f2&"
import script from "./PagesList.vue?vue&type=script&lang=ts&"
export * from "./PagesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports